import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../../config/axiosConfig";
import config from "../../../config/api";

export const updateTaskHours = createAsyncThunk(
  "projectOngoing/updateTaskHours",
  async ({ projectid, taskownerid, updatedData }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/workentries/update-tasks/${projectid}/${taskownerid}`,
         updatedData 
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markComplete = createAsyncThunk(
  "projectOngoing/markComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/workentries/${projectid}/${taskid}/complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markNonComplete = createAsyncThunk(
  "projectOngoing/markNonComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/workentries/${projectid}/${taskid}/non-complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markDescriptionComplete = createAsyncThunk(
  "projectOngoing/markDescriptionComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/descriptiontask/${projectid}/${taskid}/complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markNotDescriptionComplete = createAsyncThunk(
  "projectOngoing/markNotDescriptionComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/descriptiontask/${projectid}/${taskid}/non-complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markHardwarePartComplete = createAsyncThunk(
  "projectOngoing/markHardwarePartComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/hardware-description/${projectid}/${taskid}/complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

export const markNotHardwarePartComplete = createAsyncThunk(
  "projectOngoing/markNotHardwarePartComplete",
  async ({ projectid, taskid }, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/hardware-description/${projectid}/${taskid}/non-complete`
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);



export const completeProject = createAsyncThunk(
  "projectOngoing/completeProject",
  async (projectid, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.put(
        `${config.backendUrl}/project/mark-complete`,
        { projectid } // 👈 sending as body
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);


export const salesProjectcompleteFinal = createAsyncThunk(
  "projectOngoing/salesProjectcompleteFinal",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await axiosInstance.post(
        `${config.backendUrl}/managerProjectRequested/final-complete`,
        payload   // 👈 payload goes as the request body
      );
      return res.data;
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message);
    }
  }
);

const projectOngoingSlice = createSlice({
  name: "projectOngoing",
  initialState: {
    loading: false,
    error: null,
    data: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(updateTaskHours.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateTaskHours.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(updateTaskHours.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markDescriptionComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markDescriptionComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markDescriptionComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markNonComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNonComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markNonComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markNotDescriptionComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNotDescriptionComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markNotDescriptionComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(completeProject.pending, (state) => {
        state.loading = true;
      })
      .addCase(completeProject.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(completeProject.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(salesProjectcompleteFinal.pending, (state) => {
        state.loading = true;
      })
      .addCase(salesProjectcompleteFinal.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(salesProjectcompleteFinal.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markHardwarePartComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markHardwarePartComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markHardwarePartComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(markNotHardwarePartComplete.pending, (state) => {
        state.loading = true;
      })
      .addCase(markNotHardwarePartComplete.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markNotHardwarePartComplete.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default projectOngoingSlice.reducer;
